import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';


import fondo from '../../assets/img/landingPage/fondo.png';

import features_1 from '../../assets/img/landingPage/testing/UTesting_01.png'
import features_2 from '../../assets/img/landingPage/testing/UTesting_02.png'
import features_3 from '../../assets/img/landingPage/testing/UTesting_03.png'

import icon_1 from '../../assets/img/landingPage/testing/icn_Testing-01.png'
import icon_2 from '../../assets/img/landingPage/testing/icn_Testing-02.png'
import icon_3 from '../../assets/img/landingPage/testing/icn_Testing-03.png'

import logo from '../../assets/img/logos/AVAP_Testing-negativo.svg'
import dividerbg from '../../assets/img/landingPage/hexagono-horizonte.png'




import gradientbottom from '../../assets/img/landingPage/gradientbottom.png'
import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'


const UnitTestingProduct = () => {
    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    return (
        <>
            <FlNav></FlNav>
            <div id="pricing" 
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroProduct" className="text-center pt-5">
                    <img
                        src={logo}
                        alt="Logo AVAP Unit Testing"
                        className="img-fluid logo"
                    />
                    <h1 className="fl-title m-0">Reliable API Unit Testing Automation</h1>
                    <p className="fl-subtitle">
                        Streamline API quality assurance with AI-powered unit tests.
                    </p>
                    <a className="glowBtn-dark fakeHide" href="#"><span className="btnInner">  Start with AVAP Cloud</span></a>
                </section>

                {/* Powerful API Platform */}
                <section className="container text-center pb-5">
                    <div className="row">
                        <div className="col">
                            {/* <p className="fl-subtitle mb-3">
                                Titulo
                            </p> */}
                            {/* <img
                                src="https://placehold.co/1026x423"
                                alt="Platform Placeholder"
                                className="img-fluid mt-4 mb-5"
                            /> */}
                            <p className="fl-subtitle mb-3">
                            Comprehensive Unit Testing to Ensure Robust API Performance and Quality
                            </p>
                            <p className="fl-text">
                             AVAP Unit Testing is a dedicated tool for creating, executing, and managing automated unit tests for your APIs within AVAP Framework. Designed to improve API reliability and accelerate development cycles, it leverages Gen-AI to generate intelligent test cases, detect anomalies, and reduce manual effort, enabling faster bug detection and higher code quality.

                            </p>
                        </div>
                    </div>

                </section>

                {/* Features */}
                           <section className="container pb-5">
                    <div className="row">
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_1} alt="icon_1" />
                                <p>AI-Enhanced Unit Test </p>
                            </div>
                        </div>
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_2} alt="icon_2" />
                                <p>Detailed Test Reporting</p>
                            </div>
                        </div>
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_3} alt="icon_3" />
                                <p>AI-Powered Debugging</p>
                            </div>
                        </div>
                    </div>
                </section> 

                {/* Beyond a Proxy */}
                <section className="container py-5 gradient-d fl-br-20 mb-5">
                    <div className="row align-items-center">
                        <div className="col-md-6 text-center">
                            <img
                                src={features_1}
                                alt="Image of a code repository representing the organization and management of code for version control"
                                className="img-fluid"
                                style={{ width: '80%', height: 'auto' }}
                            />
                        </div>
                        <div className="col-md-6 pr-5">

                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">AI-Powered Test Creation & Execution</h3>
                            <p className="fl-text">
                            Harness Gen-AI to automatically create and execute intelligent unit tests that cover edge cases and complex scenarios. This accelerates testing cycles while ensuring comprehensive API validation with minimal manual input.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Comprehensive API Management */}
                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">
                        <div className="col-md-6 pl-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Mocking & Simulation of API Behavior</h3>
                            <p className="fl-text">
                            Simulate API endpoints, data sources, and dependencies to isolate and test individual API components. AI-driven behavior modeling improves simulation accuracy, enabling realistic test environments for thorough validation.


                            </p>
                        </div>

                        <div className="col-md-6 text-center">
                            <img
                                src={features_2}
                                alt="Image of version tracking system in AVAP API Source Control."
                                className="img-fluid"
                                style={{ width: '80%', height: 'auto' }}
                            />
                        </div>
                    </div>

                </section>

                <section className="container py-5 gradient-d fl-br-20  mb-5">
                    <div className="row align-items-center">

                        <div className="col-md-6 text-center">
                            <img
                                src={features_3}
                                alt="Visual representation of code evolution showing the progression of changes and updates."
                                className="img-fluid"
                                style={{ width: '90%', height: 'auto' }}
                            />
                        </div>



                        <div className="col-md-6 pr-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Comprehensive Reporting & AI-Driven Debugging Tools
                            </h3>
                            <p className="fl-text">
                            Leverage AI to analyze test results and logs, pinpointing anomalies and potential issues with actionable insights. This accelerates troubleshooting, helping developers fix defects efficiently before deployment.
                             </p>
                        </div>

                    </div>
                </section>

                <section className="container fl-z-index-2 position-relative mb-8">
                    <div className="row">
                        <div className="col mb-5">
                            <div className="fl-title text-center mb-3">
                                Key Benefits
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                Accelerate Development Cycles with AI Automation
                                </p>
                                <p className="fl-text">
                                Automate repetitive testing tasks using AI-generated tests, reducing manual effort and speeding up your API release process without compromising quality.
                                    &nbsp;
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                Improve API Reliability & Quality with Intelligent Testing

                                </p>
                                <p className="fl-text">
                                Catch defects early and test more comprehensively using AI insights, minimizing risks and enhancing overall API stability and performance.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                Seamless Integration with AVAP Ecosystem
                                </p>
                                <p className="fl-text">
                                Built to work natively within AVAP Framework, ensuring smooth workflows and consistent API lifecycle management enhanced by AI capabilities.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>


                {/* Getting Started */}
                <div className="bottomWrapper position-relative d-flex justify-content-center">
                    <img src={gradientbottom} alt="" className="gradient gradientBottom" />
                </div>
            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default UnitTestingProduct;
